import { intersectionBy, unionBy, find } from 'lodash';
import { currentUser } from './../_selectors/auth.selectors';
import { AppState } from './../../reducers/index';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, combineLatest, from, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Store, select } from '@ngrx/store';
import { Permission } from '../../../views/pages/admin/models/permission.model';
import { PageViewService } from '../../../views/pages/page-view/page-view.service';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private store: Store<AppState>, private service: PageViewService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return combineLatest([
      this.store.pipe(select(currentUser)),
      this.service.getPageBySlug(route.paramMap.get('page')).pipe(map((page) => page.permissions)),
    ]).pipe(
      switchMap(([user, permissions]) => {
        if (user) {
          if (permissions && permissions.length) {
            if (!!find(user.roles, { name: 'admin' })) {
              return of(true);
            }

            const rolesPermissions: Permission[] = [];
            user.roles.forEach((role: any) => rolesPermissions.concat(role.permissions));

            const activePermissions = unionBy(
              intersectionBy(rolesPermissions, user.permissions, 'id'),
              user.permissions,
              'id',
            ).map((permission) => permission.name);

            if (activePermissions && activePermissions.length) {
              const ret = activePermissions.some((permission: string) =>
                permissions
                  .map((perm: Permission) => perm.name)
                  .concat(['admin'])
                  .includes(permission),
              );

              return ret ? of(true) : from(this.router.navigate(['/', 'dashboard'])).pipe(map(() => false));
            }
          }

          return of(true);
        }

        return from(this.router.navigate(['/', 'dashboard'])).pipe(map(() => false));
      }),
    );
  }
}
